var render, staticRenderFns
import script from "./VDataIterator.vue?vue&type=script&lang=js&"
export * from "./VDataIterator.vue?vue&type=script&lang=js&"
import style0 from "./VDataIterator.vue?vue&type=style&index=0&id=1d8b1258&lang=scss&scoped=true&"
import style1 from "./VDataIterator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b1258",
  null
  
)

export default component.exports